import { h, Component } from 'preact';
import style from './style';

import Back from '../../../components/back';
import { route } from 'preact-router';
import { apiGetRequest, apiPostRequest, apiDeleteRequest } from '../../../components/utils/api';
import Header from '../../../components/header';
import { toast } from 'react-toastify';

import moment from 'moment';

var classNames = require('classnames/bind');
var cx = classNames.bind(style);

export default class TeamAPIKeys extends Component {
	constructor(props) {
        super(props);
        this.state = {
            keys: [],
            loading: true
        }
    }

    getAPIKeys() {
        apiGetRequest("teams/api-key/list?team=" + this.props.team.url_identifier, "", true, this.props.authToken).then((data) => {
            console.log(data);
            this.setState({keys: data, loading: false})
        })
    }

    createNewKey() {
        apiPostRequest("teams/api-key/create/?team=" + this.props.team.url_identifier, "", true, this.props.authToken).then((data) => {
            let keys = this.state.keys;
            keys.push(data);
            this.setState({keys: keys});
        })
    }

    deleteKey(id, index) {
        apiDeleteRequest("teams/api-key/delete/" + id + "/?team=" + this.props.team.url_identifier, "", true, this.props.authToken).then((data) => {
            if (data.ok) {
                let keys = this.state.keys;
                keys.splice(index, 1);
                this.setState({keys: keys});
            }
        })
    }

    copy(inputKey) {
        this[inputKey].select();
        document.execCommand('copy');
        toast.success("🚀 API Key Copied!");
        this.props.mixpanel.track("API Key Copied");
    }

    componentDidMount() {
        this.getAPIKeys();
    }

	render() {
        if (this.state.loading) {
            return;
        }
		return (
			<div class={cx("home")}>
                <Header />

                <div class={cx("content")}>
                    <Back 
                        cta={"Back to Management"}
                        callback={() => {
                            route("/team/management/")
                        }}
                    />
                    <h2>{this.props.team.team_name}'s API Keys</h2>
                    <div class={cx("button-container")}>
                        <button class={cx("button-base", "button-success")} type="button" onClick={() => this.createNewKey()}>
                            <p>Create new API Key</p>
                        </button>
                    </div>
                    {this.state.keys.length != 0 &&
                        <div class={cx("api-table")}>
                            <div class={cx("titles")}>
                                <div>
                                    <p>Key</p>
                                </div>
                                <div>
                                    <p>Date Created</p>
                                </div>
                                <div>
                                    <p>Delete</p>
                                </div>
                            </div>
                            {this.state.keys.map((item, index) => (
                                <div class={cx("api")}>
                                    <div class={cx("key")}>
                                        <div style={{display: "flex", width: "90%", justifyContent: "space-around"}}>
                                            <input 
                                                ref={(elem) => this["input" + index] = elem}
                                                onClick={() => {
                                                    this.copy("input" + index);
                                                }}
                                                value={item.key}
                                                readonly
                                                
                                            />
                                            <button type="button" class={cx("button-base", "button-success", "button-copy")} onClick={() => this.copy("input" + index)}>
                                                <p>Copy</p>
                                            </button>
                                        </div>
                                    </div>
                                    <div>
                                        <p>{moment(item.date_created).format("dddd, MMMM Do YYYY, h:mm:ss a")}</p>
                                    </div>
                                    <div class={cx("button-container")}>
                                        <button style={{marginTop: 0}} class={cx("button-base", "button-danger")} type="button" onClick={() => this.deleteKey(item.id, index)}>
                                            <p>Delete API Key</p>
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    }
                    {this.state.keys.length == 0 &&
                        <p style={{textAlign: "center"}}>You don't have any keys! Click the button above to create some keys!</p>
                    }
                </div>
			</div>
		)
	}
}




// WEBPACK FOOTER //
// ./routes/teams/teamAPIKeys/index.js